'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.types = undefined;

var _types;

var _sources = require('ui-addon-upgrades/_core/common/data/upgradeData/properties/sources');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var types = exports.types = (_types = {}, _defineProperty(_types, _sources.sourceKeys.GENERAL, 'Hand Raise'), _defineProperty(_types, _sources.sourceKeys.UPGRADE_BUTTON, 'Hand Raise'), _defineProperty(_types, _sources.sourceKeys.USAGE_LIMIT, 'Usage Limit'), _defineProperty(_types, _sources.sourceKeys.FEATURE_LIMIT, 'Feature Limit'), _defineProperty(_types, _sources.sourceKeys.CHECKOUT, 'Checkout'), _defineProperty(_types, _sources.sourceKeys.CONTACT_SALES_BUTTON, 'Hand Raise'), _defineProperty(_types, _sources.sourceKeys.CONTACT_SALES, 'Hand Raise'), _defineProperty(_types, _sources.sourceKeys.TRIAL, 'Trial'), _defineProperty(_types, _sources.sourceKeys.TRIAL_BUTTON, 'Trial'), _defineProperty(_types, _sources.sourceKeys.EXPIRED_TRIAL_MODAL, 'Trial'), _defineProperty(_types, _sources.sourceKeys.SALE, 'Sale'), _defineProperty(_types, _sources.sourceKeys.LOCKED_FEATURE, 'Locked Feature'), _defineProperty(_types, _sources.sourceKeys.LOCKED_APP, 'Locked App'), _defineProperty(_types, _sources.sourceKeys.PRODUCT_ACTIVATION, 'Product Activation'), _defineProperty(_types, _sources.sourceKeys.STANDALONE, 'Standalone'), _types);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/data/upgradeData/properties/types.js
// module id = 448
// module chunks = 3 4 5